import { Component } from '@angular/core';
import { ReportService } from 'src/app/services/report.service';

@Component({
  selector: 'app-ai-report',
  templateUrl: './ai-report.component.html',
  styleUrls: ['./ai-report.component.css']
})
export class AiReportComponent {

  constructor(
    public reportService: ReportService
  ) { }

  expandedTools = false;
  showMenu = false;

  generatedText = '';
  title = 'Herramientas de IA';

  startTextGenerator(content: 'patient-history' | 'terminology' | 'causes' | 'treatment' | 'prevention' | 'complementary_tests') {
    this.showMenu = false;
    this.generatedText = '';
    let counter = 0;
    let maxLength = 0;
    let textContent = '';
    switch (content) {
      case 'patient-history':
        textContent = this.reportService.aiData!.patient_history;
        maxLength = this.reportService.aiData!.patient_history.length;
        this.title = 'Historia del paciente';
        break;
      case 'terminology':
        textContent = this.reportService.aiData!.terminology;
        maxLength = this.reportService.aiData!.terminology.length;
        this.title = 'Explicación de términos del informe original';
        break;
      case 'causes':
        textContent = this.reportService.aiData!.causes;
        maxLength = this.reportService.aiData!.causes.length;
        this.title = 'Posbles causas';
        break;
      case 'treatment':
        textContent = this.reportService.aiData!.treatment;
        maxLength = this.reportService.aiData!.treatment.length;
        this.title = 'Posible tratamiento';
        break;
      case 'prevention':
        textContent = this.reportService.aiData!.prevention;
        maxLength = this.reportService.aiData!.prevention.length;
        this.title = 'Prevención';
        break;
      case 'complementary_tests':
        textContent = this.reportService.aiData!.complementary_tests;
        maxLength = this.reportService.aiData!.complementary_tests.length;
        this.title = 'Pruebas complementarias';
        break;
    }
    const int = setInterval(() => {
      // Si se ha modificado el texto, se detiene la generación
      if(this.generatedText != textContent.slice(0, counter)) {
        clearInterval(int);
        return;
      }
      counter++;
      this.generatedText = textContent.slice(0, counter);
      // const component = document.getElementById('dynamic-text');
      // if (component) {
      //   component.scrollTop = component.scrollHeight;
      // }
      if (this.generatedText.length === maxLength) {
        clearInterval(int);
      }
    }, 15);
  }

  expandTools() {
    this.expandedTools = true;
    setTimeout(() => {
      this.showMenu = true;
    }, 500);
  }

  collapseTools() {
    this.expandedTools = false;
    this.showMenu = false;
  }

}
